var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E6F2F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2311 19.5V13H8V10H10.2311V7.90499C10.2311 5.62288 11.6758 4.5 13.7116 4.5C14.6868 4.5 15.5249 4.5726 15.7691 4.60505V6.98999L14.3572 6.99063C13.25 6.99063 13 7.51675 13 8.28878V10H16L15 13H13V19.5H10.2311Z",
    fill: "#007CBE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNFNkYyRjkiLz4KPHBhdGggZD0iTTEwLjIzMTEgMTkuNVYxM0g4VjEwSDEwLjIzMTFWNy45MDQ5OUMxMC4yMzExIDUuNjIyODggMTEuNjc1OCA0LjUgMTMuNzExNiA0LjVDMTQuNjg2OCA0LjUgMTUuNTI0OSA0LjU3MjYgMTUuNzY5MSA0LjYwNTA1VjYuOTg5OTlMMTQuMzU3MiA2Ljk5MDYzQzEzLjI1IDYuOTkwNjMgMTMgNy41MTY3NSAxMyA4LjI4ODc4VjEwSDE2TDE1IDEzSDEzVjE5LjVIMTAuMjMxMVoiIGZpbGw9IiMwMDdDQkUiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };